import { render, staticRenderFns } from "./CarrierQuestionsMapping.vue?vue&type=template&id=8baa5774&scoped=true&"
import script from "./CarrierQuestionsMapping.vue?vue&type=script&lang=js&"
export * from "./CarrierQuestionsMapping.vue?vue&type=script&lang=js&"
import style0 from "./CarrierQuestionsMapping.vue?vue&type=style&index=0&id=8baa5774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baa5774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8baa5774')) {
      api.createRecord('8baa5774', component.options)
    } else {
      api.reload('8baa5774', component.options)
    }
    module.hot.accept("./CarrierQuestionsMapping.vue?vue&type=template&id=8baa5774&scoped=true&", function () {
      api.rerender('8baa5774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/CarrierQuestionsMapping.vue"
export default component.exports